import { useMutation } from "@tanstack/react-query";

import { updatePhoneNumber } from "~/providers/api/verificationCode";

export const useUpdatePhoneNumber = () => {
  return useMutation({
    mutationFn: updatePhoneNumber,
  });
};
